export const getSearchObject = (location) => {
    let search = new URLSearchParams(location.search);
    return Object.fromEntries(search);
};